// Orchestrates the two independent save requests fired from the Credit Report modal:
// the payment schedule (savePaymentSchedule) and the debt selection (saveDebtByUserId).
//
// Both thunks use `rejectWithValue`, so a failed dispatch RESOLVES (it does not throw) —
// a plain try/catch never sees the failure. We inspect `meta.requestStatus` on the resolved
// action and treat only an explicit `fulfilled` as success (so an `undefined` result from a
// swallowed pre-dispatch throw is NOT read as success). Awaiting both also removes the
// previous fire-and-forget ordering.

export const isRejected = (res) => res?.meta?.requestStatus === 'rejected'
export const isFulfilled = (res) => res?.meta?.requestStatus === 'fulfilled'

export const saveDebtsAndPlan = async ({ savePayment, saveDebt }) => {
  const [paymentRes, debtRes] = await Promise.all([savePayment(), saveDebt()])
  const ok = isFulfilled(paymentRes) && isFulfilled(debtRes)
  return { ok, paymentRes, debtRes }
}
